export const irisTopLineOfficeAddress = '1115 Broadway, 12th Floor'
export const irisBottomLineOfficeAddress = 'New York, NY 10010'
export const irisOfficeAddress = `${irisTopLineOfficeAddress}, ${irisBottomLineOfficeAddress}`
export const wildTopLineOfficeAddress = '2236 SE 10th Ave'
export const wildBottomLineOfficeAddress = 'Portland, OR 97214'
export const wildOfficeAddress = `${wildBottomLineOfficeAddress}, ${wildBottomLineOfficeAddress}`
